/** Where sign-out lands. Always reached with a full page load: the Clarity tag
 *  has no stop, and a reload is what ends the recording (issue #727). */
export const SIGNED_OUT_PATH = '/login';

export function hardNavigate(path: string): void {
  window.location.assign(path);
}
